// The social assistant's sign-up starts with a record of the intent, so the account
// it creates, by Google or by email, is marked as an assistant sign-up and not as a
// TutorNetworking teacher set up for bookings. See SocialAssistantSignupIntent.

export const SOCIAL_ASSISTANT_START_PATH = '/social-assistant/start'
const INTENT_PATH = '/social-assistant/intent'

function csrfHeaders() {
  const token = document.querySelector('[name="csrf-token"]')?.content
  return token ? { 'X-CSRF-Token': token } : {}
}

// A failed record must not block signing in, so this never rejects: the dialog
// opens either way, and the account is then an ordinary one.
export async function recordSocialAssistantIntent() {
  try {
    await fetch(INTENT_PATH, { method: 'POST', credentials: 'same-origin', headers: csrfHeaders() })
  } catch (_) {
    // see above
  }
}

// The visitor closed the dialog without signing up. The intent only means "is
// signing up for the assistant right now", so it must not outlive that: a teacher
// who registers elsewhere within the hour is an ordinary teacher.
export async function clearSocialAssistantIntent() {
  try {
    await fetch(INTENT_PATH, { method: 'DELETE', credentials: 'same-origin', headers: csrfHeaders() })
  } catch (_) {
    // the cookie expires within the hour regardless
  }
}
